import { useEffect, useState } from 'react';
import { T, Var, useGT } from 'gt-react';
import { MarkdownWYSIWYGEditor } from 'src/components/common/MarkdownWYSIWYGEditor';
import { Button } from 'src/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/components/ui/dialog';

interface BulkEditDescriptionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedCount: number;
  onSubmit: (description: string | null) => Promise<void>;
  isSubmitting: boolean;
}

export function BulkEditDescriptionDialog({
  open,
  onOpenChange,
  selectedCount,
  onSubmit,
  isSubmitting,
}: BulkEditDescriptionDialogProps) {
  const gt = useGT();
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (open) setDescription('');
  }, [open]);

  async function handleSubmit() {
    const trimmed = description.trim();
    await onSubmit(trimmed.length > 0 ? trimmed : null);
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            <T>Edit Description</T>
          </DialogTitle>
          <DialogDescription>
            <T>
              Set the description for <Var>{selectedCount}</Var> selected tasks.
            </T>
          </DialogDescription>
        </DialogHeader>

        <MarkdownWYSIWYGEditor
          key={open ? 'open' : 'closed'}
          initialValue={description}
          onChange={setDescription}
          placeholder={gt('Enter description for all selected tasks')}
          height={200}
          showToolbar
        />

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            <T>Cancel</T>
          </Button>
          <Button
            onClick={() => {
              void handleSubmit();
            }}
            disabled={isSubmitting}
          >
            {isSubmitting
              ? gt('Updating...')
              : gt('Update {count} tasks', {
                  count: String(selectedCount),
                })}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
